var map = {
	"./BB.png": "5bf1",
	"./BNP.png": "384b",
	"./BP.png": "ccde",
	"./BPS.png": "8af1",
	"./CA.png": "a65b",
	"./CE.png": "3744",
	"./CIC.png": "016c",
	"./CM.png": "e483",
	"./LCL.png": "74e1",
	"./Paypal.png": "43f3",
	"./SG.png": "e375"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "450e";